module.exports = __webpack_public_path__ + "static/img/75.e353d49.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/75.png
// module id = orXh
// module chunks = 1